import React from 'react'
import "./Footer.css"
import logo from "../NavBar/NavBar_Images/logo.png"
import FooterInfo from './FooterInfo'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <>
            {/* <!-- Footer --> */}
            <footer>
                {/* <!-- first --> */}
                <div class="footer_first">
                    <FooterInfo icon="fa-solid fa-location-dot" heading="Location" text="Pakistan" />
                    <FooterInfo icon="fa-solid fa-mobile-screen-button" heading="Contact" text="+92 3XX-XXXXXXX" />
                    <FooterInfo icon="fa-regular fa-envelope" heading="Email" text="example@xyz.com" />
                </div>

                <hr />

                {/* <!-- second footer div --> */}
                <div class="footer_second">
                    <div class="info">
                        <img src={logo} alt="Smash Code" />
                        <p>Smash Code is a Web Design & Development Company based in Pakistan, founded in 2019. We are a team of skilled Web Designers & Developers, Graphic Designers, and Content & Copy Writers.</p>
                    </div>


                    <div class="info">
                        <h3>Quick - Links</h3>
                        <ul>
                            <li><Link to="/home"><i class="fa-solid fa-house"></i> Home</Link></li>
                            <li><Link to="/about"><i class="fa-solid fa-user"></i> About</Link></li>
                            <li><Link to="/contact"><i class="fa-solid fa-phone"></i> Contact</Link></li>
                            <li><Link to="/service"><i class="fa-brands fa-servicestack"></i> Services</Link></li>
                            <li><Link to="/project"><i class="fa-solid fa-diagram-project"></i> Projects</Link></li>
                            <li><Link to="/blog"><i class="fa-solid fa-blog"></i> Blogs</Link></li>
                        </ul>
                    </div>


                    <div class="info">
                        <h3>Social - Links</h3>
                        <ul class="lastDiv">
                            <li><a href="#"><i class="fa-brands fa-facebook-f"></i></a></li>
                            <li><a href="#"><i class="fa-brands fa-twitter"></i></a></li>
                            <li><a href="#"><i class="fa-brands fa-github"></i></a></li>
                            <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                        </ul>
                    </div>
                </div>
            </footer>

            <div class="footer_third">
                <p>Copyright &copy; 2022, All Right Reserved <span><a href="#">Smash Code</a></span></p>
            </div>
        </>
    )
}

export default Footer
